const ERROR_MESSAGES = {
  PROPOSALS_LIST: 'Erro ao buscar lista de proposta',
  PROPOSAL_DETAILS: 'Erro ao buscar detalhes da proposta',
  STORAGE_COMPANY_UPDATE_ERROR: 'Erro ao incluir company no storage',
  STORAGE_USER_SETTINGS_ERROR:
    'Erro ao incluir um item de configuração do usuário no storage',
}

export { ERROR_MESSAGES }
